import { createContext, useContext, type AnchorHTMLAttributes, type ComponentType, type ReactNode } from 'react';

export interface ProprietesLien extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  children?: ReactNode;
}

function LienNatif(props: ProprietesLien) {
  return <a {...props} />;
}

const ContexteLien = createContext<ComponentType<ProprietesLien>>(LienNatif);

/**
 * Permet à l'application de fournir son composant de lien (par exemple celui du routeur)
 * aux composants de navigation, qui restent indépendants du routeur.
 */
export function FournisseurLien({ composant, children }: { composant: ComponentType<ProprietesLien>; children: ReactNode }) {
  return <ContexteLien.Provider value={composant}>{children}</ContexteLien.Provider>;
}

export function Lien(props: ProprietesLien) {
  const Composant = useContext(ContexteLien);
  return <Composant {...props} />;
}
